<template>
  <NodeViewWrapper as="a" v-bind="HTMLAttributes" :href="href || undefined">
    <LicencePlate v-if="isCar" class="mb-0 align-middle">{{ label }}</LicencePlate>
    <template v-else>{{ label }}</template>
  </NodeViewWrapper>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { NodeViewWrapper, nodeViewProps } from '@tiptap/vue-3';
import LicencePlate from '@/components/LicencePlate.vue';
import { entityLinkHref } from './comment-entity-link';

const props = defineProps(nodeViewProps);

const entityType = computed(() => props.node.attrs.entityType as unknown);
const label = computed(() => String(props.node.attrs.label ?? props.node.attrs.id ?? ''));
const isCar = computed(() => entityType.value === 'car');
const href = computed(() =>
  props.editor.isEditable ? null : entityLinkHref(entityType.value, props.node.attrs.id),
);
</script>
